
(function () {
  'use strict';

  function fensterZu(kennung) {
    return document.querySelector('[data-fenster="' + kennung + '"]');
  }

  document.addEventListener('click', function (e) {
    var auf = e.target.closest && e.target.closest('[data-fenster-auf]');
    if (auf) {
      var dlg = fensterZu(auf.getAttribute('data-fenster-auf'));
      if (dlg && dlg.showModal) {
        e.preventDefault();
        var p = dlg.parentElement;
        if (p && p !== document.body && p.checkVisibility && !p.checkVisibility()) document.body.appendChild(dlg);
        dlg.showModal();
      }
      return;
    }

    var zu = e.target.closest && e.target.closest('[data-fenster-zu]');
    if (zu) {
      var offen = zu.closest('[data-fenster]');
      if (offen) offen.close();
      return;
    }

    if (e.target.hasAttribute && e.target.hasAttribute('data-fenster')) {
      e.target.close();
    }
  });
})();
